import { Country } from 'src/enums/countries'
import { establishmentTypes } from 'src/enums/establishmentTypes'

const commercialFields: IDictionary<CommercialField> = {
  nit: {
    label: 'NIT',
    value: 'nit',
    type: 'text',
    countries: [Country.GT],
    required: true,
  },
  nrc: {
    label: 'NRC',
    value: 'nrc',
    type: 'text',
    countries: [Country.SV],
    required: true,
  },
  rtn: {
    label: 'RTN',
    value: 'nit',
    type: 'text',
    countries: [Country.HN],
    required: true,
  },
  businessName: { label: 'Razón social', value: 'name', type: 'text', required: true },
  businessAddress: {
    label: 'Dirección',
    value: 'socialAddress',
    type: 'text',
    countries: [Country.HN],
    required: true,
  },
  commercialNameSV: {
    label: 'Nombre sucursal',
    value: 'commercialName',
    type: 'text',
    required: true,
    countries: [Country.SV],
  },
  commercialName: {
    label: 'Nombre comercial',
    value: 'commercialName',
    type: 'text',
    required: true,
    notCountries: [Country.SV],
  },
  commercialAddress: {
    label: 'Dirección',
    value: 'address',
    type: 'text',
    notCountries: [Country.HN],
    required: true,
  },
  department: {
    label: 'Departamento',
    value: 'department',
    type: 'text',
    countries: [Country.SV, Country.GT],
    required: true,
  },
  county: {
    label: 'Municipio',
    value: 'municipality',
    type: 'text',
    countries: [Country.SV, Country.GT],
    required: true,
  },
  comercialEstablishment: {
    label: 'Establecimiento comercial',
    value: 'comercialEstablishment',
    type: 'text',
    countries: [Country.SV, Country.GT],
    required: true,
  },
  establishmentType: {
    label: 'Tipo de establecimiento',
    value: 'establishmentType',
    type: 'select',
    options: establishmentTypes,
    countries: [Country.SV],
    required: true,
  },
  pointOfSale: {
    label: 'Punto de venta',
    value: 'pointOfSale',
    type: 'text',
    countries: [Country.SV],
    required: false,
  },
  zip: {
    label: 'Código postal',
    value: 'postalCode',
    type: 'text',
    countries: [Country.GT],
    required: true,
  },
}

const getCommercialFields = (country: Country): CommercialField[] => {
  return Object.values(commercialFields).filter(cf => {
    let inCountry
    if (!cf.countries) inCountry = true
    else inCountry = cf.countries.some(c => c === country)

    let notCountry
    if (!cf.notCountries) notCountry = true
    else notCountry = !cf.notCountries.some(c => c === country)

    return inCountry && notCountry
  })
}

export { getCommercialFields }
